export default __webpack_public_path__ + "static/ewallet-solution-for-entertainment-and-amusement-park-14db38d1635a730b28aaa78cbb6734af.png";